'use client';

import type React from 'react';
import { Provider } from 'jotai';
import { projectStore } from '../utils/project.util';

export const ProjectProvider = ({ children }: { children: React.ReactNode }) => {
	return <Provider store={projectStore}>{children}</Provider>;
};
